import { render, staticRenderFns } from "./NetlinkInfoPopup.vue?vue&type=template&id=77b2d9b1&scoped=true&lang=html"
import script from "./NetlinkInfoPopup.vue?vue&type=script&lang=js"
export * from "./NetlinkInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./NetlinkInfoPopup.vue?vue&type=style&index=0&id=77b2d9b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2d9b1",
  null
  
)

export default component.exports